
import { Options, Vue } from 'vue-class-component';
import { FootwearEstimationClient } from '@/services/Services';
import AdditionalProperties from './components/additionalProperties.vue';
import * as OM from '@/Model';

@Options({
    components: {
        AdditionalProperties
    }
})
export default class Accessories extends Vue {

    estimationIdentifier: string = "";
    accessoriesFromConfiguration: OM.FootwearAdditionalPropertiesConfiguration[] = [];
    estimationAccessories: OM.FootwearAdditionalProperty[] = [];

    loaded: boolean = false;
    
    created() {
        this.estimationIdentifier = this.$route.params.estimationIdentifier.toString();
        this.init();
    }

    init() {
        Promise.all([
            FootwearEstimationClient.getAccessoriesFromConfiguration(),
            FootwearEstimationClient.getAccessoriesAdditionalsFromEstimation(this.estimationIdentifier)
        ])
        .then( xs => {
            this.accessoriesFromConfiguration = xs[0];
            this.estimationAccessories = xs[1];

            setTimeout(() => {
                this.loaded = true;
            }, 300);
        })
    }

    updateAdditionalProperties(model: OM.FootwearEstimationAdditionalPropertyVM) {
        FootwearEstimationClient.updateAdditionalProperties(model)
        .then(x => {
            this.$router.push('/footwear-calculator/processes-locations-and-transports/' + this.estimationIdentifier);
        })
    }
}
